export default function typeTranslation(value: string): string {
    switch (value) {
        case 'RELEASE':
            return 'Lançamento'
        case 'VENTURE':
            return 'Empreendimento'
        case 'COMMING_SOON':
            return 'Em Breve'
        case 'SELECTED':
            return 'Selecionado'
        default:
            return ''
    }
}
